import type { StateAbbreviation } from '@repo/supergraph-schemas/marketplace/types';

type FilterComponentProps = {
  ProductTypeSelect: Record<string, never>;
  LocationSelect: {
    initialLocation?: StateAbbreviation;
  };
  TermLengthSelect: Record<string, never>;
  MinDepositSelect: Record<string, never>;
  MinBalanceSelect: Record<string, never>;
  BonusSelect: Record<string, never>;
};

export interface FilterConfig {
  filters: Array<{
    component: keyof FilterComponentProps;
  }>;
}

export const FILTER_CONFIGS: Record<string, FilterConfig> = {
  'cd-rates': {
    filters: [{ component: 'TermLengthSelect' }, { component: 'MinDepositSelect' }],
  },
  'bank-bonuses-and-promotions': {
    filters: [{ component: 'ProductTypeSelect' }, { component: 'LocationSelect' }],
  },
  'paid-geo-targeted': {
    filters: [{ component: 'LocationSelect' }],
  },
  'high-yield-online-savings-accounts': {
    filters: [{ component: 'MinBalanceSelect' }, { component: 'BonusSelect' }],
  },
};

export const getFilterConfig = (slug: string): FilterConfig => {
  return FILTER_CONFIGS[slug] ?? { filters: [] };
};
